const PUSH_ENDPOINT_KEY = "web_push_endpoint";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function getStoredPushEndpoint() {
  return localStorage.getItem(PUSH_ENDPOINT_KEY);
}

export function clearStoredPushEndpoint() {
  localStorage.removeItem(PUSH_ENDPOINT_KEY);
}

function storePushEndpoint(endpoint) {
  if (endpoint) localStorage.setItem(PUSH_ENDPOINT_KEY, endpoint);
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  return reg;
}

export async function subscribeForPush(apiBaseUrl, getToken) {
  const token = getToken?.();
  if (!token) return;
  if (typeof Notification !== "undefined") {
    if (Notification.permission === "default") {
      try {
        await Notification.requestPermission();
      } catch {
        return;
      }
    }
    if (Notification.permission !== "granted") return;
  }
  const reg = await registerServiceWorker();
  if (!reg) return;
  const res = await fetch(`${apiBaseUrl}/notifications/vapid-public-key`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) return;
  const { public_key: publicKey } = await res.json();
  let subscription = await reg.pushManager.getSubscription();
  if (!subscription) {
    subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }
  const json = subscription.toJSON();
  const body = { endpoint: json.endpoint, keys: json.keys };
  const registerRes = await fetch(`${apiBaseUrl}/notifications/register-web-push`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  if (registerRes.ok) storePushEndpoint(subscription.endpoint);
}

export async function unregisterPush(apiBaseUrl, getToken) {
  const endpoint = getStoredPushEndpoint();
  if (!endpoint) return;
  const token = getToken?.();
  if (!token) {
    clearStoredPushEndpoint();
    return;
  }
  try {
    await fetch(`${apiBaseUrl}/notifications/register-web-push`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ endpoint }),
    });
  } finally {
    clearStoredPushEndpoint();
  }
}
